export enum SnackTypes {
  LOADING = 'loading',
  LOADING_WITH_CLOSE = 'loading-with-close',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
